import { createFileRoute } from "@tanstack/react-router";
import { ContractPurchaseDepartmentAnalysisPage } from "@/features/contracts/contract-purchase-department-analysis-page";
import { ensureElementVisible } from "@/lib/route-guards";

export const Route = createFileRoute(
	"/_auth/kontrakty/rozliczenia-zakup/$id/analiza-dzial-zakupow",
)({
	beforeLoad: async ({ context, location }) => {
		await ensureElementVisible(
			context.queryClient,
			"sidebar.kontrakty.szablony",
			location.pathname,
		);
	},
	component: ContractPurchaseDepartmentAnalysisPage,
});
